import { translateEmployeeProperties } from "../../translate/translateEmployeeProperties";

export const parseAvailableFilters = ({ items = [], properties }) => {
  const filterChoices = {};

  properties.forEach(({ name, translationKey }) => {
    filterChoices[name] = { name, translationKey, options: [] };
  });

  items.forEach((item) => {
    properties.forEach(({ name }) => {
      const propertyValue = item[name];
      if (
        propertyValue &&
        !filterChoices[name].options.some(({ id }) => id === propertyValue)
      ) {
        filterChoices[name].options.push({
          id: propertyValue,
          name: translateEmployeeProperties(name, propertyValue),
        });
      }
    });
  });

  return filterChoices;
};
